import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PricingRuleStockCustomItem, PricingRuleStockItem, PricingTemplate, PricingTemplateStockList } from '../models/pricing';
import { environment } from '../../environments/environment';
import { StockCustomItem, StockItem, StockList } from '../models/stock';

@Injectable({
  providedIn: 'root'
})
export class PricingService {
  
  apiUrl = 'v1/pricing/';

  constructor(private http: HttpClient) { }

  public getPricingTemplates() {
    console.log("Fetching pricing templates from API");
    return this.http.get<PricingTemplate[]>(environment.apiUrl + this.apiUrl + 'templates');
  }

  public getPricingTemplateStockList(pricingTemplateId: number) {
    return this.http.get<PricingTemplateStockList>(environment.apiUrl + this.apiUrl + 'template/' + pricingTemplateId + '/stock');
  }

  public savePricingTemplate(template: PricingTemplate) {
      return this.http.post<PricingTemplate>(environment.apiUrl + this.apiUrl + 'template/' + template.pricingTemplateId, template);
  }

  public savePricingRule(rule: PricingRuleStockItem){
      return this.http.post<PricingRuleStockItem>(environment.apiUrl + this.apiUrl + 'rule/' + rule.pricingRuleId, rule);  
  }

  public saveStockCustomPricingRule(rule: PricingRuleStockCustomItem){
      return this.http.post<PricingRuleStockCustomItem>(environment.apiUrl + this.apiUrl + 'rule/custom/' + rule.pricingRuleId, rule);  
  }

  public deletePricingRule(pricingRuleId: number) {
      return this.http.delete<void>(environment.apiUrl + this.apiUrl + 'rule/' + pricingRuleId);
  }

  public removePricingTemplate(pricingTemplateId: number) {
      return this.http.delete<void>(environment.apiUrl + this.apiUrl + 'template/' + pricingTemplateId);
  }

  public deleteStockCustomPricingRule(pricingRuleId: number) {
      return this.http.delete<void>(environment.apiUrl + this.apiUrl + 'rule/custom/' + pricingRuleId);
  }

  public getNMSFStockList() {
    return this.http.get<StockItem[]>(environment.apiUrl + this.apiUrl + 'msf');
  }

  public addNewStockItem(item: StockItem) {
    return this.http.post<StockItem>(environment.apiUrl + this.apiUrl + 'stock/new', item);
  }

  public addNewCustomStockItem(item: StockCustomItem) {
    return this.http.post<StockCustomItem>(environment.apiUrl + this.apiUrl + 'stockcustom/new', item);
  }
}
